import React from "react";
import CertificateLetter from "./Letters/CertificateLetter";

const CertificateCantabria = ({certificate}) => {

    return (
        <>
            <div className="card-body">
                <p><strong>Fecha</strong>: {certificate.register_data}</p>
                <p><strong>Numero certificado</strong>: {certificate.certificate_number}</p>
                <p><strong>Dirección</strong>: {certificate.address}</p>
                <p><strong>Zona climatica</strong>: {certificate.climatic_zone}</p>
                <p><strong>Consumo</strong>: {certificate.year_m2_consumption}</p>
                <p><strong>Emisiones </strong>: {certificate.year_m2_emissions}</p>
                <p><strong>Classificación consumo </strong>: <CertificateLetter
                    letter={certificate.heating_consumption}/></p>
                <p><strong>Classificación emisiones </strong>:<CertificateLetter
                    letter={certificate.heating_global_emissions}/></p>
            </div>
        </>

    );
}


export default CertificateCantabria;